<section>
    <table class="past-usage-table">
        <thead>
            <tr>
                <th scope="col" class="cycle-label" [ngClass]="{'hide-call-text-label': !showCallAndText}">{{ pageData.billCycleLabel }}</th>
                <th scope="col" class="text-label" *ngIf="showCallAndText">{{ pageData.textLabel }}</th>
                <th scope="col" class="call-label" *ngIf="showCallAndText">{{ pageData.callLabel }}</th>
                <th scope="col" class="data-label" [ngClass]="{'hide-call-text-label label-right': !showCallAndText}">{{ pageData.dataLabel }}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let usage of usages, let last = last">
                <td class="month" [ngClass]="{ 'last-row': last, 'hide-call-text-label': !showCallAndText }">{{ usage.cycleStartDate | date:'MMM d' }} - {{ usage.cycleEndDate | date:'MMM d' }}</td>
                <td class="text-count" [ngClass]="{ 'last-row': last }" *ngIf="showCallAndText">
                    <a uiSref="account.activity.usage" *ngIf="displayUsageLink(usage.domesticMessageCounts)"
                        [uiParams]="{ activity: messages, statement_line_id: usage.statementLineId.key, startDate: usage.cycleStartDate, endDate: usage.cycleEndDate, name: currentLine.displayName, lineNumber: currentLine.lineNumber }">
                        {{ usage.domesticMessageCounts }}
                    </a>
                    <span class="not-clickable" *ngIf="!displayUsageLink(usage.domesticMessageCounts)">{{ usage.domesticMessageCounts }}</span>
                </td>
                <td class="call-count" [ngClass]="{ 'last-row': last }" *ngIf="showCallAndText">
                    <a uiSref="account.activity.usage" *ngIf="displayUsageLink(usage.domesticVoiceCounts)"
                        [uiParams]="{ activity: call, statement_line_id: usage.statementLineId.key, startDate: usage.cycleStartDate, endDate: usage.cycleEndDate, name: currentLine.displayName, lineNumber: currentLine.lineNumber }">
                        {{ usage.domesticVoiceCounts }}
                    </a>
                    <span class="not-clickable" *ngIf="!displayUsageLink(usage.domesticVoiceCounts)">{{ usage.domesticVoiceCounts }}</span>
                </td>
                <td class="usage" [ngClass]="{ 'last-row': last, 'hide-call-text-label label-right': !showCallAndText }">{{ usage.domesticDataConsumed }} GB</td>
            </tr>
        </tbody>
    </table>
</section>
